import React, { useEffect, useState } from "react";
import GenericLayout from "../layouts/GenericLayout";
import { Link, useParams } from "react-router-dom";
import { getAllIncludedResourcesForAGivenType } from "../_helpers/jsonapi-deserializer";
import {
  useProduct,
  useProducts,
  useProductsByCategories,
  useProductsByCategory,
} from "../_services/product-services";
import _, { uniqueId } from "lodash";
import Error from "../components/Error";
import Loading from "../components/utils/Loading";
import { isEven, isOdd } from "../_helpers/compare";
import { useCategory } from "../_services/category-services";

export const isRegular = (thumb_type) => {
  return thumb_type === "regular";
};

export const isLarge = (thumb_type) => {
  return thumb_type === "large";
};

function ProductLine({ id }) {
  const { product, isLoading, isError } = useProduct(id);

  if (isLoading) return <Loading />;
  if (isError) return <Error />;
  const materials = getAllIncludedResourcesForAGivenType(product, "material");
  const { name, cover_picture_url, description } = product.data.attributes;

  return (
    <div
      key={product.id}
      className="flex lg:flex-row flex-col-reverse xl:space-x-5"
    >
      <div className="flex xl:w-vw-2/5 xl:justify-end">
        <div className="flex flex-col xl:w-vw-1/3 items-start justify-center">
          <div className="xl:mt-0 mt-4">
            <p className="font-fraunces font-bold sm:text-40 text-24 text-black uppercase">
              {name}
            </p>
          </div>
          <div className="font-helvetica text-16 text-black ">
            <p className="underline">Conditionnements</p>
            <ul className={"list-disc list-inside"}>
              {materials.map((material) => {
                return (
                  <li key={uniqueId("packing__")}>
                    {material.attributes.name}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="font-helvetica text-16 text-black mt-4">
            <p className="underline">Caractéristiques</p>
            <ul>
              <li className="italic font-medium">{description}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="xl:w-vw-2/5 w-full xl:mx-auto">
        <div
          className="imgs aspect-w-8 aspect-h-5 rounded-lg bg-cover bg-center"
          style={{
            backgroundImage: `url(${cover_picture_url})`,
          }}
        />
      </div>
    </div>
  );
}

function ProductLineReverse({ id }) {
  const { product, isLoading, isError } = useProduct(id);

  if (isLoading) return <Loading />;
  if (isError) return <Error />;
  const materials = getAllIncludedResourcesForAGivenType(product, "material");
  const { name, cover_picture_url, description } = product.data.attributes;

  return (
    <div
      key={product.id}
      className="flex lg:flex-row-reverse flex-col-reverse xl:space-x-5"
    >
      <div className="flex xl:w-vw-2/5 xl:justify-end">
        <div className="flex flex-col xl:w-vw-1/3 items-start justify-center">
          <div className="xl:mt-0 mt-4">
            <p className="font-fraunces font-bold sm:text-40 text-24 text-black uppercase">
              {name}
            </p>
          </div>
          <div className="font-helvetica text-16 text-black">
            <p className="underline">Conditionnements</p>
            <ul className={"list-disc list-inside"}>
              {materials.map((material) => {
                return (
                  <li key={uniqueId("packing__")}>
                    {material.attributes.name}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="font-helvetica text-16 text-black mt-4">
            <p className="underline">Caractéristiques</p>
            <ul>
              <li className="italic font-medium">{description}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="xl:w-vw-2/5 w-full xl:mx-auto">
        <div
          className="imgs aspect-w-8 aspect-h-5 rounded-lg bg-cover"
          style={{
            backgroundImage: `url(${cover_picture_url})`,
          }}
        />
      </div>
    </div>
  );
}

const CategoryPage = () => {
  const { category_id } = useParams();
  console.log(category_id);

  const { category } = useCategory(category_id);
  const { products, isError, isLoading } = useProductsByCategory(category_id);

  if (isError) {
    throw isError;
  }

  return (
    <GenericLayout>
      <div className="lg:w-vw-4/5 lg:mx-auto mx-4 sm:mt-20 xl:space-y-20 space-y-8 xl:mb-32">
        <div className="col-span-1 flex sm:justify-center ">
          {category && (
            <div className="flex flex-col sm:text-center">
              {/*<p className="font-birthstone sm:text-56 text-32 text-rouge z-10">*/}
              {/*  {category.data.attributes.name.split(" ")[0]}*/}
              {/*</p>*/}

              <p className="font-fraunces sm:text-56 text-32 -mt-2 text-black z-10">
                {category.data.attributes.name}
              </p>
            </div>
          )}
        </div>
        {!isLoading &&
          products.data.map(({ id }, index) => {
            return isEven(index) ? (
              <ProductLine key={uniqueId("product_line--")} id={id} />
            ) : (
              <ProductLineReverse key={uniqueId("product_line--")} id={id} />
            );
          })}
      </div>
    </GenericLayout>
  );
};

export default CategoryPage;
